import styled from 'styled-components';
import { media, mediaQuery } from '../../common/styles/styleUtil';

interface TabBarExtraContentProps {
  fontSize?: string;
  fontWeight?: string;
}
interface CustomTabProps {
  disabled?: boolean;
  active?: boolean;
}
export const TabBarExtraContent = styled.div<TabBarExtraContentProps>`
  color: #333f48;
  margin: 0 24px 0 0;
  font-size: ${(props) => (props.fontSize ? props.fontSize : '20px')};
  font-weight: ${(props) => (props.fontWeight ? props.fontWeight : '900')};
  line-height: 22px;
  ${media.lg`
    display: none;
   `};
`;

export const CustomTabBar = styled.div`
  display: flex;
  margin-bottom: 24px;
  align-items: flex-end;
  @media (${mediaQuery.tablet}) {
    display: block;
  }
`;

export const CustomTab = styled.span<CustomTabProps>`
  margin: -4px 0 -4px;
  color: ${(props) =>
    props.disabled
      ? 'rgba(0, 0, 0, 0.25)'
      : props.active
        ? '#2f8dcd'
        : '#697684'};
  font-weight: 500;
  &:hover {
    transition: hover 0.3s;
    color: ${(props) => (props.active ? '#2f8dcd' : '#333f48')};
  }
`;
